import Vue from 'vue';
import gql from 'graphql-tag';
import get from 'lodash/get';
import casesService from '~lib/common/providers/casesService';
import mediaQueries from '~lib/common/queries/LabAsset';

import walkNodes from './walkNodes';

function setMediaPayload(payload, caseConf) {
  // Add media to payload
  payload.medias = [];
  walkNodes(payload, ['LAB_ASSET_VIEWED', 'LAB_ASSET_AVAILABLE'], (nodeData) => {
    const image = findImage(caseConf._labAssets, nodeData.url);
    if (image) {
      payload.medias.push({
        key: image.labAsset.key,
        asset: {
          enabled: image.asset.enabled,
          name: image.asset.name,
          url: image.asset.url
        }
      });
    }
  });
}

function findImage(labAssets, url) {
  for (const labAsset of labAssets) {
    const assets = get(labAsset, 'options.assets', []);
    const asset = assets.find(a => a.url === url);
    if (asset) {
      return { labAsset, asset };
    }
  }
  return null;
}

async function pasteMedia(caseConf, payload) {
  if (payload.medias.length <= 0) {
    return false;
  }

  // Fetch lab assets if case doesn't have any
  const response = await casesService.query({
    query: gql(mediaQueries.fetch),
    variables: {},
    fetchPolicy: 'no-cache',
  });
  const fetchedLabAssets = response.data.labAssets.map(la => ({ ...la }));

  for (const media of payload.medias) {
    const existingLabAsset = (caseConf._labAssets || []).find(la => la.key === media.key);
    if (existingLabAsset) {
      if (!existingLabAsset.options.assets.find(a => a.url === media.asset.url)) {
        existingLabAsset.options.assets.push(media.asset);
      }
    } else {
      const fetchedLabAsset = fetchedLabAssets.find(la => la.key === media.key);
      if (!caseConf._labAssets) {
        Vue.set(caseConf, '_labAssets', []);
      }
      caseConf._labAssets.push({
        id: fetchedLabAsset.id,
        key: fetchedLabAsset.key,
        options: {
          assets: [ media.asset ]
        }
      });
    }
  }

  return true;
}

export {
  setMediaPayload,
  pasteMedia,
};
